import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../globals';
import { User, SessionUser} from '../service/modal/user';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../service/apiservice/login.service';
import { pincode } from '../service/modal/pincode';
import { Observable, of } from 'rxjs';
import { UtilFunctions } from '../util-functions';
import { InsurancePolicy } from '../service/modal/insurancepolicy';
declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-updateprofile',
  templateUrl: './updateprofile.component.html',
  styleUrls: ['./updateprofile.component.css']
})
export class UpdateprofileComponent implements OnInit {
userInfo:User;
userForm: FormGroup;
  submitted=false;
  options;
  bloodgroupsDropDown: String[] = ["Don't Know", "A Positive", "A Negative", "B Negative", "B Positive", "AB Negative", "AB Positive", "O Negative", "O Positive"];
  bloodDropDown_SelectedId: number[];
  pincodeDropDown: any;
  pincodeDropDown_SelectedId: number[];
  genderDropDown: String[] = ["None", "Male", "Female", "Other", "Transgender"];
  genderDropDown_SelectedId: number[];
  pincodeList: pincode[];
  filteredOptions: Observable<pincode[]>;
  selectedPincode;
  pincode;

  policyNameDropDown;

  

  constructor(private _loginService:LoginService,private global:Globals,private router:Router,private formBuilder:FormBuilder) { }

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
   this.loadEmptyCustomerForm();
    this.getUserInfoById();
    // this.userInfo=this.global.loggedUser.user;
   
  }

  getUserInfoById(){
    this._loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(response=>{
      this.userInfo =response;
      this.loadWithDataCustomerForm(this.userInfo);
    },err=>{});
   
  }






  loadEmptyCustomerForm()
  {
    this.userForm = this.formBuilder.group({
      'user_reg_id': ['', Validators.required],
      'firstName': ['', Validators.required],
      'middleName': ['', Validators.required],
      'lastName': ['', Validators.required],
      'gender': ['', Validators.required],
      'bloodGroup': ['', ''],
      'dob': ['', Validators.required],
      'age': ['', Validators.required],
      'pinCode': ['', Validators.required],
      'postalAddress': ['', Validators.required],
      'emailAddress':['',Validators.required],
      'address':['',''],
      'emergencyName':['',''],
      'emergencyConatctNo':['',''],
      // 'policyNo':['',''],
      // 'policyName':['','']
      'policyDetails':['',''],
      'personalEmailId':['','']
    });
  }

  loadWithDataCustomerForm(user:User) {
    debugger;
    this.userForm=this.formBuilder.group({
      'user_reg_id':[user.user_reg_id],
      "firstName": [user.firstName, Validators.required],
      'middleName': [user.middleName, ''],
      'lastName': [user.lastName, Validators.required],
      'gender': [user.gender, Validators.required],
      'bloodGroup': [user.bloodGroup, ''],
      'dob': [user.dob, Validators.required],
      'age': [user.age, ''],
      'pinCode': [user.pinCode, Validators.required],
      'postalAddress': [user.postalAddress, Validators.required],
      'emailAddress': [user.emailAddress, Validators.required],
      'address':[user.address,''],
     'emergencyName':[user.emergencyName,''],
     'emergencyConatctNo':[user.emergencyConatctNo,''],
    //  'policyNo':[user.policyNo,''],
    //  'policyName':[user.pollicyName,''],
    'policyDetails':[user.policyDetails,''],
    'personalEmailId':[user.personalEmailId,''],
     'profileImgPath': [user.profileImgPath, ''],



    });
    this.selectedPincode =user.postalAddress;

  }




  // loadWithDataCustomerForm(userInfo: User) {
  //   this.userForm = this.formBuilder.group({
  //     'user_reg_id': [userInfo.user_reg_id, Validators.required],
  //     'mobileNumber': [userInfo.mobileNumber, Validators.required],
  //     'firstName': [userInfo.firstName, Validators.required],
  //     'middleName': [userInfo.middleName,],
  //     'lastName': [userInfo.lastName,],
  //     'gender': [userInfo.gender, Validators.required],
  //     'bloodGroup': [userInfo.bloodGroup, ''],
  //     'dob': [userInfo.dob, Validators.required],
  //     'age': [userInfo.age, Validators.required],
  //     'pinCode': [userInfo.pinCode, Validators.required],
  //     'postalAddress': [userInfo.postalAddress, Validators.required],
  //     'emailAddress': [userInfo.emailAddress, Validators.required],
  //     'address': [userInfo.address, ''],
  //     'usedRefCode': [userInfo.usedRefCode, ''],
  //     'personalEmailId': [userInfo.personalEmailId, ''],
  //     'profileImgPath': [userInfo.profileImgPath, ''],
  //     'emergencyName': [userInfo.emergencyName, ''],
  //     'emergencyConatctNo': [userInfo.emergencyConatctNo, ''],
  //     'policyDetails': [userInfo.policyDetails, ''],
  //     'healthHistory': [userInfo.healthHistory, ''],
  //     'other': [userInfo.other, ''],
  //     'otp': ['', Validators.required],
  //     'promoCode': [userInfo.promoCode, ''],
  //     'role': [userInfo.role, ''],
  //   });

  //   this.selectedPincode = userInfo.postalAddress;
  //   this.loadHealthHistory();
  // }






createEmailId(){
var name=  this.userForm.get('firstName').value
// var emailid=  this.userForm.get('emailAddress').value;
// var newemailid=emailid.split(".")[0]+"."+this.userForm.get('firstName').value+"@mdhl.in";

var newemailid=this.userInfo.mobileNumber+"."+name.toLowerCase()+"@mdhl.in"
this.userForm.controls['emailAddress'].setValue('');
this.userForm.controls['emailAddress'].setValue(newemailid);
}
  UpdateUser()
  {
    this.submitted=true;
    if(this.userForm.valid)
    {
      debugger;
      console.log(this.userForm.value);
     
      this._loginService.updateProfile(this.userForm.value)
      .subscribe((response)=>
      {
        this.global.loggedUser.user=new SessionUser
        Object.assign(this.global.loggedUser.user,response);
        UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
        // window.location.reload();
         info_noti('User Profile Updated Successfully');
      
        this.router.navigate(['/dashboard/profile']);
      },
      error=>
      {
         info_noti('update failed');
        console.log(error);
      })

    }
  }
  ageCalculator() {
    
    // let { AgeFromDateString } = require('age-calculator');

      // let ageFromString = new AgeFromDateString(this.userForm.get('dob').value).age;
      let ageFromString= this.getAge(this.userForm.get('dob').value);
      this.userForm.controls['age'].setValue(ageFromString);
      // this.age = ageFromString;

      console.log("value from ageFromString", ageFromString);
  
  }

  getAge(dateString) {
    if(dateString!==""){
    var now = new Date();
   
    var dob = new Date(dateString.substring(0,4),
      dateString.substring(5,7)-1 ,
      dateString.substring(8, 10),now.getHours(),now.getMonth(),now.getSeconds()
    );

  

  //Get difference between years
var years = now.getFullYear() - dob.getFullYear();
  var  currMonth = now.getMonth() + 1;
  var birthMonth = dob.getMonth() + 1;
var months=0;
var days=0;
  //Get difference between months
  months = currMonth - birthMonth;

  //if month difference is in negative then reduce years by one 
  //and calculate the number of months.
  if (months < 0)
  {
     years--;
     months = 12 - birthMonth + currMonth;
     if (now.getDate() < dob.getDate())
        months--;
  } else if (months == 0 && now.getDate() < dob.getDate())
  {
     years--;
     months = 11;
  }

  //Calculate the days
  if (now.getDate() > dob.getDate())
     days = now.getDate() - dob.getDate();
  else if (now.getDate() < dob.getDate())
  {
     var today = now.getMonth();
     now.getMonth(), -1;
     days = now.getMonth() - dob.getMonth() + today;
  } 
  else
  {
     days = 0;
     if (months == 12)
     {
        years++;
        months = 0;
     }
  }
  //Create new Age object 
  // return new Age(days, months, years);


  if (years > 0) {
  
    return  years+ " Years";
  } else if (months > 0) {
   
    return  months+ " Months";
  } else {
    
    return days+ " Days";
  }
    }



  }



  getSelectedPincode(event) {
    $("selectFilter").val(event.option.value.pincode);
    this.pincode = event.option.value.pincode;
    this.selectedPincode = event.option.value.pincode + "-" + event.option.value.postofficenamearea + "," + event.option.value.districtname + "," + event.option.value.statename + " [" + event.option.value.divisionname + "]";
    this.userForm.controls['pinCode'].setValue(event.option.value.pincode);
    this.userForm.controls['postalAddress'].setValue(this.selectedPincode);
   
    console.log(this.selectedPincode);
  }
  getpincode() {

    if (this.userForm.get('pinCode').value.length == 6) {
      this._loginService.GetPincode(this.userForm.get('pinCode').value).subscribe((response) => {
        // this.pincodeDropDown=response;
        this.pincodeList = response;
        this.filteredOptions = of(this.pincodeList);
        console.log(this.pincodeList);
      }, error => {
        this.selectedPincode = "";
      });
    }

  }
  emergencyContactNo(){
    $(document).ready(function () {
      $("#emergencyContactNo").keypress(function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          $("#errmsg").html("Digits Only").show().fadeOut("slow");
          return false;
        }
      });
    });
  }
 
  addCancelClick(){
    this.router.navigate(['/dashboard/profile']);
  }

  firstNameEnter(){
    $('#middleName').focus();
  }
middelNameEnter(){
  $('#lastName').focus();
}
lastNameEnter(){
  $('#mdhlId').focus();
}
mdhlIdEnter(){
  $('#gender').focus();
}
genderEnter(){
  $('#bloodgroup').focus();
}
bloodGroupEnter(){
  $('#dob').focus();
}
dobEnter(){
  $('#age').focus();
  this.ageCalculator();
}
ageEnter(){
  $('#emailId').focus();
}
emailIdEnter(){
  $('#address').focus();
}
addressEnter(){
  $('#pincode').focus();
}
pincodeEnter(){
  $('#emergencyContactNo').focus();
}
emergencyContactNoEnter(){
  $('#emergencyName').focus();
}

emergencyNameEnter(){
  $('#policyDetails').focus();
}
policyDetailsEnter(){
  $('#updateBtn').focus();
 this.UpdateUser();
  
}
}

export class Age {
  years: number;
  months: number;
  days: number;
}








































